import { SourceDataEventStatus } from "@/api/dtos";

const sourceDataEventStatusToText = (status?: SourceDataEventStatus) => {
    switch (status) {
        case SourceDataEventStatus.Complete:
            return 'Complete';
        case SourceDataEventStatus.Locked:
            return 'Locked';
        case SourceDataEventStatus.Skipped:
            return 'Skipped';
        case SourceDataEventStatus.Started:
            return 'Started';
        case SourceDataEventStatus.None:
        default:
            return 'Not Started'
    }
}

export default sourceDataEventStatusToText;